<template lang="html">
  <h1 class="black--text" style="margin: 2em auto;">
    ◆店舗特典
  </h1>

  <div style="width: 90%; margin: 0 auto;">
    <div class="card-container d-flex justify-center flex-wrap">
      <v-card
        class="mr-3 mb-3"
        width="380"
        variant="outlined"
        v-for="card in cardList"
        :key="card.title"
      >
        <v-img :src="getImageUrl(card.imageUrl)" height="380"></v-img>
        <v-card-title>{{ card.title }}</v-card-title>
        <v-card-subtitle class="card-subtitle">
          <p v-html="card.subtitle.replace(/<br>/g, '<br />')"></p>

          <!-- {{ card.subtitle }} -->
        </v-card-subtitle>
        <v-card-text>
          <span v-if="card.linkUrl1"
            ><v-btn variant="outlined" class="mr-3">
              <a
                :href="card.linkUrl1"
                class="card-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                通常版</a
              >
            </v-btn>
            <!-- v-ifの条件付きレンダリングでパラメータがあるときだけボタンを出している -->
          </span>
          <span v-if="card.linkUrl2"
            ><v-btn variant="outlined"
              ><a
                :href="card.linkUrl2"
                class="card-link"
                target="_blank"
                rel="noopener noreferrer"
                >限定版</a
              ></v-btn
            >
          </span>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<style>
  .card-container {
    display: flex;
  }

  .card-link {
    text-decoration: none;
    color: black;
  }
  .card-subtitle {
    white-space: normal !important;
    overflow: auto;
    text-overflow: ellipsis;
  }
</style>
<script>
  export default {
    data() {
      return {
        cardList: [
          {
            imageUrl: "ebtn1.png",
            title: "エビテン様",
            linkUrl1: "https://ebten.jp/p/7015023072724/",
            linkUrl2: "https://ebten.jp/p/7015023072723/",
            subtitle: "オリジナルB3タペストリー",
          },
          {
            imageUrl: "ebtn2.png",
            title: "エビテン様",
            linkUrl1: "https://ebten.jp/p/7015023072722/",
            linkUrl2: "https://ebten.jp/p/7015023072721",
            subtitle:
              "3Dクリスタルセット「博麗霊夢」<br>オリジナルB3タペストリー",
          },
          {
            imageUrl: "wngoo.png",
            title: "WonderGoo様",
            linkUrl2: "https://www.wonder.co.jp/benefit/game/detail/?id=26958",
            subtitle: "A3タペストリー",
          },
          {
            imageUrl: "amiami.png",
            title: "あみあみ様",
            linkUrl1:
              "https://www.amiami.jp/top/detail/detail?scode=GAME-0028595",
            linkUrl2:
              "https://www.amiami.jp/top/detail/detail?scode=GAME-0028596",
            subtitle: "アクリルキーホルダー",
          },
          {
            imageUrl: "sofmap.png",
            title: "ソフマップ様",
            linkUrl2: "https://www.sofmap.com/product_detail.aspx?sku=80037664",
            subtitle: "B2タペストリー",
          },
          {
            imageUrl: "animate.png",
            title: "アニメイト様",
            linkUrl1: " https://www.animate-onlineshop.jp/pn/pd/2259236/ ",
            linkUrl2: " https://www.animate-onlineshop.jp/pn/pd/2259235/  ",
            subtitle: "霧雨 魔理沙 マイクロファイバーミニタオル",
          },
          {
            imageUrl: "gs1983.png",
            title: "ゲームショップ1983様",
            linkUrl1:
              "https://shop.1983.jp/shop/shop.cgi?order=&class=all&keyword=%93%8C%95%FB&FF=0&price_sort=&pic_only=&mode=p_wide&id=37345&superkey=1",
            linkUrl2:
              "https://shop.1983.jp/shop/shop.cgi?order=&class=all&keyword=%93%8C%95%FB&FF=0&price_sort=&pic_only=&mode=p_wide&id=37346&superkey=1",
            subtitle:
              "東方蒼神縁起V　単独パッケージ想定ジャケット+互換ソフトケース<br>東方幻想魔録W　単独パッケージ想定ジャケット+互換ソフトケース",
          },
          {
            imageUrl: "amazon.png",
            title: "Amazon様",
            linkUrl1: "https://amzn.asia/d/iMJCqJI",
            linkUrl2: "https://amzn.asia/d/1vHPJl0",
            subtitle: "オリジナルPC & スマホ壁紙",
          },
        ],
      };
    },
    methods: {
      getImageUrl(imagePath) {
        return require(`@/assets/${imagePath}`);
        //return require(`../assets/${imagePath}`).default;
      },
    },
  };
</script>
